import { EntityCatalog } from 'src/app/shared/components/entity-catalog/entity-catalog.types';

/**
 * Document registry screen — step 4 of onboarding a country.
 *
 * These rows drive what a customer is asked to capture, how the number is validated, and which
 * fields the AI service extracts. Before this screen existed, adding a country's national ID
 * meant editing DOCUMENT_TYPE_SEEDS and redeploying.
 */
export const DOCUMENT_TYPE_CATALOG: EntityCatalog = {
  title: 'Document Types',
  singular: 'Document Type',
  idKey: 'code',
  facetFieldKey: 'country_pack',
  facetAllLabel: 'All countries',
  // SELFIE and PASSPORT carry no country pack because no one country owns them; they get an
  // option of their own rather than appearing under every country.
  facetBlankLabel: 'Every country',
  fields: [
    {
      key: 'code',
      label: 'Code',
      kind: 'text',
      inList: true,
      required: true,
      immutable: true,
      placeholder: 'EMIRATES_ID',
      hint: 'Uppercase. Referenced by captures and rule packs, so it cannot change later.',
    },
    {
      key: 'country_pack',
      label: 'Country pack',
      kind: 'enum',
      inList: true,
      options: [],
      hint: 'Leave blank for a document every country uses (SELFIE, PASSPORT).',
    },
    {
      key: 'category',
      label: 'Category',
      kind: 'enum',
      inList: true,
      required: true,
      options: [
        'IDENTITY',
        'ADDRESS',
        'INCOME',
        'BANKING',
        'BUREAU',
        'BIOMETRIC',
        'BUSINESS',
      ],
      hint: 'IDENTITY and ADDRESS also name the document in that country’s OCR prompts.',
    },
    { key: 'display_name', label: 'Display name', kind: 'text', inList: true, required: true },
    {
      key: 'id_regex',
      label: 'Number format (regex)',
      kind: 'text',
      placeholder: '^[0-9]{15}$',
      hint: 'Validated when saved — a broken pattern would otherwise reject every capture.',
    },
    {
      key: 'identify_patterns',
      label: 'Identify patterns',
      kind: 'tags',
      hint: 'Text that marks a scan as this document.',
    },
    { key: 'reject_message', label: 'Reject message', kind: 'text' },
    { key: 'has_expiry', label: 'Has expiry', kind: 'boolean' },
    { key: 'expiry_grace_days', label: 'Expiry grace (days)', kind: 'number' },
    { key: 'mrz_expected', label: 'MRZ expected', kind: 'boolean' },
    {
      key: 'requirement_key',
      label: 'Requirement key',
      kind: 'text',
      hint: 'Set this to have the document collected in a customer journey.',
    },
    { key: 'requirement_hint', label: 'Requirement hint', kind: 'text' },
    { key: 'product_slugs', label: 'Products', kind: 'tags', placeholder: 'agentic-pd, agentic-kyc' },
    { key: 'requirement_order', label: 'Order', kind: 'number' },
    // No 'Mandatory' control here on purpose: whether a document is required depends on which
    // journey collects it (the same PAN is mandatory in a lending flow, optional in a light-touch
    // KYC one), so the workflow decides that now, not this per-document global flag.
    { key: 'min_ocr_confidence', label: 'Min OCR confidence', kind: 'number' },
    {
      key: 'status',
      label: 'Status',
      kind: 'enum',
      inList: true,
      options: ['ACTIVE', 'INACTIVE'],
    },
  ],
};
